import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Table from "../../../components/commonComponent/Table"; 
import useLoader from "../../../hooks/useLoader";
import useModal from "../../../hooks/useModal";
import ContactUsViewModal from "./ContactUsViewModal";
import { BsWhatsapp } from "react-icons/bs";
import { useTable, useFilters } from "react-table";
import SummaryModal from "../../../components/commonComponent/summaryModal";


const API_URL = process.env.REACT_APP_API_URL;

const columns = [
  { header: "Name", accessor: "name" },
  { header: "Mobile", accessor: "mobile" },
  { header: "Reach Out", accessor: "type" },
 {
    header: "Status",
    accessor: "followup",
    render: (row) => {
      const followups = row.followup || [];
      const latest = followups.length > 0 ? followups[followups.length - 1].status : "N/A";
      return <span className="text-sm text-gray-700">{latest}</span>;
    },
  },
  { header: "Date", accessor: "createdAt" },
  { header: "Whatsapp", accessor: "actions" },
];

const ContactUS = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  console.log(data,"datadatadata");

  const [showSummary, setShowSummary] = useState(false);
  const [summaryRow, setSummaryRow] = useState(null);

  const { loading, showLoader, hideLoader } = useLoader();
  const {
    showViewModal,
    selectedItem,
    handleOpenViewModal,
    handleCloseViewModal,
  } = useModal();

const [filters, setFilters] = useState({
  search: "",
  date: "",
});

const openSummary = (row) => {
  setSummaryRow(row);
  setShowSummary(true);
};

const closeSummary = () => {
  setShowSummary(false);
  setSummaryRow(null);
};

  // Function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.error("Invalid date:", dateString);
      return "Invalid Date";
    }
    const options = {
      year: "2-digit",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };
    return date.toLocaleString("en-GB", options).replace(",", "").replace(/\//g, "-");
  };

  // Function to send a WhatsApp message with a custom message
  const sendWhatsAppMessage = (mobile) => {
    const message = "Thank you for reaching out. We have received your concern and will contact you as soon as possible.";
    const whatsappUrl = `https://wa.me/${mobile}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank"); // Open WhatsApp in a new tab or window
  };

  // Add this above useEffect
const fetchContacts = async () => {
  showLoader();
  try {
    const response = await fetch(`${API_URL}/contactus/getContacts`);
    if (!response.ok) {
      throw new Error("Failed to fetch contacts");
    }
    const result = await response.json();

   const updatedData = result.map((item) => ({
  ...item,
  Status: "followup", // ✅ default if backend has no status
  createdAt: formatDate(item.createdAt),
  actions: (
    <button
      className="btn-bg p-4 text-xl flex items-center justify-center rounded-full"
      onClick={() => sendWhatsAppMessage(item.mobile)}
      style={{
        backgroundColor: "#25D366",
        color: "white",
        fontSize: "10px",
        width: "50px",
        height: "50px",
        borderRadius: "50%",
      }}
    >
      <BsWhatsapp size={30} style={{ color: "white" }} />
    </button>
  ),
}));


    const sortedData = updatedData.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    setData(sortedData);
  } catch (error) {
    setError(error);
    toast.error("Error fetching contacts: " + error.message);
  } finally {
    hideLoader();
  }
};


  // Fetching contacts and formatting data
  useEffect(() => {
    const fetchContacts = async () => {
      showLoader();
      try {
        const response = await fetch(`${API_URL}/contactus/getContacts`);
        if (!response.ok) {
          throw new Error("Failed to fetch contacts");
        }
        const result = await response.json();
        
        // Format the date and add a custom 'actions' field to each item
        const updatedData = result.map((item) => ({
          ...item,
          Status: "followup",
          createdAt: formatDate(item.createdAt), // Format the date
          actions: (
            <button
              className="btn-bg p-4 text-xl flex items-center justify-center rounded-full"
              onClick={() => sendWhatsAppMessage(item.mobile)}
              style={{
                backgroundColor: "#25D366", // WhatsApp green color
                color: "white",  // Icon color
                fontSize: "10px",  // Adjust button size
                width: "50px",  // Adjust width for larger button
                height: "50px",  // Adjust height for larger button
                borderRadius: "50%",  // Circular button
              }}
            >
              <BsWhatsapp size={30} style={{ color: "white" }} />  {/* WhatsApp icon size and color */}
            </button>
          ),
        }));

        // Sort the data by createdAt in descending order (most recent first)
        const sortedData = updatedData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        setData(sortedData);
      } catch (error) {
        setError(error);
        toast.error("Error fetching contacts: " + error.message);
      } finally {
        hideLoader();
      }
    };

    fetchContacts();
  }, []);

  // React Table Hook (useFilters for filtering functionality)
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns: columns,
      data: data,
      initialState: {
        filters: [],
      },
    },
    useFilters // Adds the filtering capability
  );

  const fieldsToShow = {
  Name: "name",
  Email: "email",
  Mobile: "mobile",
  Message: "message",
  Pincode: "pincode",
  quantity: "quantity",
  avgMonthlyBill: "avgMonthlyBill",
 "Follow Up Summary": (data) => {
  if (!data.followup || data.followup.length === 0) return "No follow-up yet.";
  return (
    <ul className="list-disc ml-5 space-y-1">
      {[...data.followup]
        .sort((a, b) => new Date(b.date) - new Date(a.date))
        .map((item, idx) => (
          <li key={idx}>
            <strong>{item.status}</strong>
            {item.message && ` - ${item.message}`}{" "}
            <span className="text-gray-500 text-xs">
              ({new Date(item.date).toLocaleString()})
            </span>
          </li>
        ))}
    </ul>
  );
},

};

  

  // Function to handle date filter
  const handleDateChange = (e) => {
    setFilters({ ...filters, date: e.target.value });
  };

  return (
    <div>
      <h2 className="capitalize font-bold text-[24px] mb-4">Contacts Us</h2>

      {error && <div className="error-message">{error.message}</div>}

      {/* Search Filter */}
      <div className="mb-4">
        <input
          type="text"
          value={filters.search}
          onChange={(e) => {
            setFilters({ ...filters, search: e.target.value });
          }}
          placeholder="Search by name or mobile"
          className="p-2 border rounded"
        />
      </div>

      {/* Date Filter */}
      <div className="mb-4">
        <input
          type="date"
          value={filters.date}
          onChange={handleDateChange}
          className="p-2 border rounded"
        />
      </div>

      <div className="table-container">
        <Table
          columns={columns}
          data={data.filter((item) => {
            const isSearchMatch =
              item.name.toLowerCase().includes(filters.search.toLowerCase()) ||
              item.mobile.includes(filters.search);

            const isDateMatch = filters.date
              ? item.createdAt.includes(filters.date) // Filter by date if provided
              : true;

            return isSearchMatch && isDateMatch; // Combine search and date filters
          })}
          showIndex={true}
          loading={loading}
          onView={handleOpenViewModal}
        actions={{
          showView: true,
          customActions: [
            {
              label: "📝", // summary icon
              buttonClass: "bg-gray-200 hover:bg-gray-300",
              onClick: openSummary,
            },
          ],
        }}
      />
    </div>

      <ContactUsViewModal
        show={showViewModal}
        onHide={handleCloseViewModal}
        data={selectedItem}
        fields={fieldsToShow}
      />

    <SummaryModal
      show={showSummary}
      onHide={closeSummary}
      row={summaryRow}
      refreshData={fetchContacts} // ✅ new prop
    />
    </div>
  );
};

export default ContactUS;
